export default __webpack_public_path__ + "static/media/xbox-series-x-seeklogo.com.c492acfe.svg";